module.exports = __webpack_public_path__ + "media/volvo/assets/images/facebook@2x-8f47b12b7a4182401e06224d6ba5fa05.png";